import {
  deleteContractScopeItemTask,
  getContractScopeItems,
  storeContractScopeItemTask,
  updateContractScopeItem,
  updateContractScopeItemStatus,
  updateContractScopeItemTask
} from "../../api-helpers/contracts/api-job-tracking";

import $moment from "moment";

export default {
  state: {
    isGettingContractScopeItems: false,
    contractScopeItems: null,
    isUpdatingContractScopeItem: false,
    isStoringContractScopeItemTask: false,
    isUpdatingContractScopeItemTask: false,
    isUpdatingContractScopeItemStatus: false,
    isDeletingContractScopeItemTask: false
  },
  mutations: {
    setIsGettingContractScopeItems(state, bool) {
      state.isGettingContractScopeItems = bool;
    },
    setContractScopeItems(state, contractScopeItems) {
      state.contractScopeItems = contractScopeItems;
    },
    setIsStoringContractScopeItemTask(state, bool) {
      state.isStoringContractScopeItemTask = bool;
    },
    setIsUpdatingContractScopeItemTask(state, bool) {
      state.isUpdatingContractScopeItemTask = bool;
    },
    setIsUpdatingContractScopeItemStatus(state, bool) {
      state.isUpdatingContractScopeItemStatus = bool;
    },
    setIsDeletingContractScopeItemTask(state, bool) {
      state.isDeletingContractScopeItemTask = bool;
    }
  },
  actions: {
    async getContractScopeItems({ state, commit }, data) {
      let contractScopeItems = state.contractScopeItems;
      if (!state.isGettingContractScopeItems && data && data.contractId) {
        commit("setIsGettingContractScopeItems", true);

        contractScopeItems = await getContractScopeItems(
          data.contractId,
          !!data.unassignedOnly
        );
        commit("setContractScopeItems", contractScopeItems);

        commit("setIsGettingContractScopeItems", false);
      }
      return contractScopeItems;
    },
    async storeContractScopeItemTask({ state, commit, dispatch }, task) {
      let response;
      if (!state.isStoringContractScopeItemTask) {
        commit("setIsStoringContractScopeItemTask", true);

        response = await storeContractScopeItemTask(task);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Task stored successfully.",
          errorText: "An error occurred while attempting to store Task.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            dispatch("getContractScopeItems", { contractId: task.contract_id });
          }
        });

        commit("setIsStoringContractScopeItemTask", false);
      }
      return response;
    },
    async updateContractScopeItem({ state, commit, dispatch }, task) {
      let response;
      if (!state.isUpdatingContractScopeItem) {
        commit("setIsUpdatingContractScopeItemTask", true);

        response = await updateContractScopeItem(task);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Task updated successfully.",
          errorText: "An error occurred while attempting to update Task.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            if (task.isDashboardView) {
              dispatch("getMyTasks");
            } else if (task.isAdminDashboardView) {
              dispatch("getScheduledCrews");
            } else {
              dispatch("getContractScopeItems", {
                contractId: task.contract_id
              });
            }
          }
        });

        commit("setIsUpdatingContractScopeItemTask", false);
      }
      return response;
    },
    async updateContractScopeItemTask({ state, commit, dispatch }, task) {
      let response;
      if (!state.isUpdatingContractScopeItemTask) {
        commit("setIsUpdatingContractScopeItemTask", true);

        response = await updateContractScopeItemTask(task);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Task updated successfully.",
          errorText: "An error occurred while attempting to update Task.",
          afterSuccessFunction: () => {
            commit("resetCreateEditComponentParams");
            if (task.isDashboardView) {
              dispatch("getMyTasks");
            } else if (task.isAdminDashboardView) {
              dispatch("getScheduledCrews");
            } else {
              dispatch("getContractScopeItems", {
                contractId: task.contract_id
              });
            }
          }
        });

        commit("setIsUpdatingContractScopeItemTask", false);
      }
      return response;
    },
    async updateContractScopeItemStatus({ state, commit, dispatch }, item) {
      let response;
      if (!state.isUpdatingContractScopeItemStatus) {
        commit("setIsUpdatingContractScopeItemStatus", true);

        response = await updateContractScopeItemStatus(item);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Item status updated successfully.",
          errorText:
            "An error occurred while attempting to update Item status.",
          afterSuccessFunction: () => {
            if (item.isDashboard) {
              dispatch("getMyTasks");
            } else {
              dispatch("getContractScopeItems", {
                contractId: item.contract_id
              });
            }
          }
        });

        commit("setIsUpdatingContractScopeItemStatus", false);
      }
      return response;
    },
    async deleteContractScopeItemTask({ state, commit, dispatch }, task) {
      let response;
      if (!state.isDeletingContractScopeItemTask) {
        commit("setIsDeletingContractScopeItemTask", true);

        response = await deleteContractScopeItemTask(task);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Task deleted successfully.",
          errorText: "An error occurred while attempting to delete Task.",
          afterSuccessFunction: () => {
            commit("resetConfirmationModalParams");
            if (task.isDashboardView) {
              dispatch("getMyTasks");
            } else {
              dispatch("getContractScopeItems", {
                contractId: task.contract_id
              });
            }
          }
        });

        commit("setIsDeletingContractScopeItemTask", false);
      }
      return response;
    }
  },
  getters: {
    jobTrackingItems: state => {
      if (state.contractScopeItems) {
        let scopes = state.contractScopeItems;
        return scopes.map(scope => {
          let scopeItems = scope.work_scope_items;
          // ported in some of Urbans' computed scope items logic //
          if (scopeItems) {
            scopeItems
              .sort((a, b) => a.name.localeCompare(b.name))
              .map(item => {
                item.tasks
                  .sort(
                    (a, b) =>
                      new Date(a.scheduled_for) - new Date(b.scheduled_for) ||
                      a.name.localeCompare(b.name)
                  )
                  .map(task => {
                    task.nestedFiles = {
                      files: task.files.map(f => {
                        return {
                          ...f,
                          viewClickAction: () => {
                            const win = window.open(f.url);
                            win.focus();
                          },
                          deleteClickAction: () => {
                            const formData = Object.assign({}, task);
                            delete formData.nestedFiles;
                            formData.files.splice(task.files.indexOf(f), 1);

                            this.$store.dispatch(
                              "updateContractScopeItemTask",
                              formData
                            );
                          }
                        };
                      })
                    };

                    task.completionCheckboxInfo = {
                      value: task.status === "completed",
                      label: "Completed",
                      changeHandler(val) {
                        task.status = val ? "completed" : "not-started";
                        this.$store.dispatch(
                          "updateContractScopeItemTask",
                          task
                        );
                      }
                    };

                    if (task.user) {
                      task.userName = task.user.name;
                    }

                    if (Array.isArray(task.scheduled_for)) {
                      task.scheduledDate = task.scheduled_for.reduce(
                        (acc, date, i) => {
                          if (i > 0) {
                            acc += ", ";
                          }

                          return `${acc}${$moment(date).format("MM/DD/YYYY")}`;
                        },
                        ""
                      );
                    } else {
                      task.scheduledDate = task.scheduled_for
                        ? $moment(task.scheduled_for).format("MM/DD/YYYY")
                        : "";
                    }

                    return task;
                  });

                return item;
              });
            scope.work_scope_items = scopeItems;
            return scope;
          }
          // /ported in some of Urbans' computed scope items logic //
        });
      } else {
        return false;
      }
    }
  }
};
